// Distinct color generator using the golden-angle hue rotation. Adjacent
// indices differ by ~137.5°, which keeps similar indices visually distinct.

const GOLDEN_ANGLE_DEG = 137.508;

function hsl(hue: number, sat: number, light: number, alpha = 1): string {
  const h = ((hue % 360) + 360) % 360;
  if (alpha === 1) return `hsl(${h.toFixed(1)}deg ${sat}% ${light}%)`;
  return `hsla(${h.toFixed(1)}deg ${sat}% ${light}% / ${alpha})`;
}

// One stable color per searched word. Word index 0 is the warmest; subsequent
// words rotate around the wheel by the golden angle.
export function wordColor(wordIndex: number, alpha = 1): string {
  return hsl(8 + wordIndex * GOLDEN_ANGLE_DEG, 75, 58, alpha);
}

// Deprecated: per-hit color. Still used in some places as a fallback.
export function hitColor(i: number, alpha = 1): string {
  return hsl(i * GOLDEN_ANGLE_DEG, 70, 55, alpha);
}

// Background color for cells where multiple words co-occur. Slightly
// desaturated so it doesn't compete with the per-word colors.
export function blendedColor(_alpha = 0.5): string {
  return "rgba(255,255,255,0.85)";
}

// Backward-compatibility alias used by the matrix view, which colors
// cluster cells the same way the heatmap colors per-word cells.
export function clusterColor(wordIndex: number, alpha = 1): string {
  return wordColor(wordIndex, alpha);
}
